module.exports = __webpack_public_path__ + "static/media/landing.6fb21e5f.png";